import React from 'react';
import { IconButton } from '@mui/material';
import { deleteButton } from './styles';
import { Close } from '../icons/Close';

type DeletePhotoButtonProps = {
  handleInitDelete: (e: React.MouseEvent<HTMLButtonElement>) => void;
};

export const DeletePhotoButton = ({ handleInitDelete }: DeletePhotoButtonProps) => (
  <IconButton size="small" color="inherit" onClick={(e) => handleInitDelete(e)} sx={deleteButton}>
    <Close variant="white" />
  </IconButton>
);
